<template>
<!--  临床应用-->
  <div class="productPage">
    <!--图片-->
    <div class="imgBox">
      <div class="imageItem">
        <img :src="imgBoxUrl" class="el-image__inner">
      </div>
    </div>
    <!--    导航-->
    <div class="num_all">
      <el-row >
        <el-col :span="18" :justify="end" ><div class="grid-content num_r">
          <el-menu :default-active="numIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item  v-for="item in numList" :index="item.num" :indexPath="item.path">{{item.tital}}</el-menu-item>
          </el-menu>
        </div></el-col>
      </el-row>
    </div>

    <div class="contentBox" v-show="showData.box1">
      <div class="cu_all">
        <div class="cli_d_1">{{ item.text1 }}</div>
        <div class="cli_img">
          <el-image
            style="width: 1176px; height: 700px"
            :src="item.imageUrl"
            :fit="contain" v-show="showData.img1"></el-image>
          <video :src="videoUrl" v-show="showData.video1"></video>
        </div>
        <div class="cli_d_2" v-if="item.text2 != ''" >{{item.text2}}</div>
      </div>

    </div>
    <div class="contentBox" v-show="showData.box2">
      <div class="cu_all">
        <div class="cli_d_1">{{ item2.text1 }}</div>
        <div class="cli_img">
          <el-image
            style="width: 1176px; height: 700px"
            :src="item2.imageUrl"
            :fit="contain" v-show="showData.img2"></el-image>
          <video v-show="showData.video2" width="1176" height="700" controls>
            <source :src="videoUrl2" type="video/mp4">
          </video>
        </div>
        <div class="cli_d_2" v-if="item2.text2 != ''" >{{item2.text2}}</div>
      </div>

    </div>

  </div>
</template>

<script>
import Mun2 from "./image/mun2";
export default {
  name: "clinical",
  components: {Mun2},
  data() {
    return {
      videoUrl:"",
      videoUrl2:"http://116.62.38.250//image/nr/jjfa/11.mp4",
      numList : [
        {
          num : "1",
          tital : "Periodontal Disease Treatment",
          path: "yz"
        },
        {
          num : "2",
          tital : "Pediatric Dental Treatment",
          path: "er"
        },
      ],
      imgBoxUrl:"http://116.62.38.250//image//nr/tp/lcyy.jpg",
      urlData:"",
      showData:{
        box1: false,
        box2: false,
        img1: false,
        video1: false,
        img2: false,
        video2: false
      },
      numIndex: "1",
      item:{
        text1:"Periodontal Disease Treatment",
        imageUrl:"http://116.62.38.250//image/nr/lcyy/item.jpg",
        text2:"Periodontal disease is a chronic infectious condition caused by plaque microorganisms. It primarily consists of two types: gingivitis, which affects only the gum tissue, and periodontitis, which involves deeper periodontal structures such as the periodontal ligament, alveolar bone, and cementum. With the continuous advancements in laser technology, lasers and laser-assisted treatments have opened new avenues for the non-surgical management of periodontal disease. Among the various laser wavelengths, the Er:YAG laser stands out for its exceptional safety and effectiveness, making it widely used in all stages of periodontal disease treatment.\n" +
          "Er:YAG is a mid-infrared laser with a wavelength of 2.94μm, which is very close to the absorption peak of water (2.95μm) and the OH- in hydroxyapatite (2.8μm). This makes it the most easily absorbed laser wavelength in aqueous environments. Consequently, the Er:YAG laser can safely and efficiently cut through hard dental tissues while precisely managing soft tissues, all without causing thermal damage to surrounding areas. Additionally, it offers antibacterial, disinfectant, painless, and low-bleeding benefits.\n" +
          "Compared to traditional treatment methods, the Er:YAG laser significantly reduces patient discomfort and pain during procedures. It also minimizes vibration, effectively alleviating the pain and anxiety associated with dental treatments. These features make laser technology a more comfortable and efficient choice in modern periodontal treatments."
      },
      item2:{
        text1:"Pediatric Dental Treatment",
        imageUrl:"http://116.62.38.250//image/nr/lcyy/item.jpg",
        text2:"The application of Er:YAG laser in treating hard tissue diseases in pediatric dentistry is extensive. Traditional methods for removing caries typically rely on mechanical tools, which often produce noise that can scare children, making it difficult for them to cooperate. In contrast, Er:YAG laser treatment offers several significant advantages in caries removal:\n" +
          "1.High Safety: The Er:YAG laser does not generate excessive heat, ensuring that the dental pulp tissue is not damaged.\n" +
          "2.Selective Removal of Carious Tissue: The laser selectively targets water-rich carious tissue, providing more precise treatment.\n" +
          "3.Strong Control: With a penetration depth of only about 5 microns, the Er:YAG laser allows for precise control, minimizing damage to healthy tissues.\n" +
          "4.Enhanced Comfort: Compared to traditional caries removal methods, laser treatment causes less discomfort, with many patients considering it a more comfortable option.\n" +
          "Both Er:YAG and Er,Cr:YSGG lasers can reduce microleakage on tooth surfaces, likely due to the opening of dentinal tubules and the reduction of the smear layer following laser treatment. The Er:YAG laser removes carious tissue through a \"micro-explosion\" mechanism. When the water in the tooth absorbs the laser energy, it rapidly evaporates, causing an internal pressure spike that breaks away the outer hard tissue.\n" +
          "The cutting efficiency of the Er:YAG laser varies depending on the water content of the tissue. For example, dentin, with its higher water content, is removed faster than enamel. Similarly, carious tissue is removed more quickly than healthy hard tissue, and the removal of caries from primary teeth is faster than from permanent teeth.\n" +
          "Studies have shown that Er:YAG laser removes caries from primary teeth about 1.5 times faster than from permanent teeth. Therefore, for pediatric patients, especially those who are less cooperative, laser treatment is an effective option."
      }
    }
  },
  mounted() {
    let that = this;
    console.log("init");
    that.init();
  },
  created() {
    let that = this;
    that.urlData = that.$route.query.path;
    console.log(that.urlData);

  },
  methods: {
    init(){
      let that = this;
      console.log(that.urlData);
      console.log(that.urlData == undefined);
      if(that.videoUrl == ""){
        that.showData.img1 = true;
      } else {
        that.showData.video1 = true;
      }

      if(that.videoUrl2 == ""){
        that.showData.img2 = true;
      } else {
        that.showData.video2 = true;
      }
      if(that.urlData == "" || that.urlData == undefined){
        that.handleSelect("1",'ey')
      } else {
        let index = "1";
        if(that.urlData == 'er'){
          index = "1";
        } else  {
          index = that.urlData;
        }

        that.handleSelect(index,that.urlData)
      }

    },

    handleSelect(index, path) {
      let that = this;
      that.numIndex = index;
      console.log(index+path)  //获取tab标签的选中值
      console.log(index, path);
      //初始化
      that.showData.box1 = false;


      if(index == '1'){
        that.showData.box2 = false;
        that.showData.box1 = true;
      } else if(index == '2'){
        that.showData.box2 = true;
        that.showData.box1 = false;
      }
    }
  }
}
</script>

<style scoped>
.num_all{
  background: #ffffff;
  font-family: SourceHanSansCN;
  font-size: 12px;
  text-align: justify;
  height: 60px;
  width: 100%;
}
.num_r{
  float: right;
}
.cli_img{
  margin-top: 35px;
  margin-bottom: 25px;
}
.cli_d_2{
  font-family: SourceHanSansCN;
  font-size: 18px;
  color: #666666;
  letter-spacing: 0.39px;
  text-align: justify;
  line-height: 32px;
  white-space: pre-wrap;
}
.cli_d_1{
  font-family: SourceHanSansCN;
  font-size: 36px;
  color: #333333;
  text-align: justify;
}
.cu_all{
  width: 1176px;
}
.contentBox {
  width: 1176px;
  margin: 50px auto;
  display: flex;
  justify-content: center;
}
.productPage {
  display: block;
  width: 1920px;
  background-color: #FFFFFF;
}
.imgBox {
  width: 100%;
  height: 600px;
}

.imageItem {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/en/clinical.vue